import React, { Component } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import rightarrow from '../../../assets/img/icons/rightarrow.svg'
import activearrow from '../../../assets/img/icons/activearrow.svg'
import Deactivate from './components/deactivate';
import Delete from './components/delete';
import ChangeePassword from './components/changepassword';
import ChangeLanguage from './components/changelanguage'
import Information from './components/information';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class Settings extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
    }

    render() {
        return (
            <div className="common_layout">
                <div className='header_layout'>
                    <div className='header_title margin_auto'>
                        <h4><Trans i18nKey="Settings">Settings</Trans></h4>
                    </div>
                </div>
                <div className='mt_3'>
                    <Container>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="information">
                            <Row>
                                <Col md={5}>
                                    <div className=''>
                                        <Nav variant="pills" className="flex-column settings_tab">
                                            <Nav.Item>
                                                <Nav.Link eventKey="information" className='settings_a'>
                                                    <h4><Trans i18nKey="Information">Information</Trans></h4>
                                                    <img src={rightarrow} alt='img' className="nrml_img" />
                                                    <img src={activearrow} alt='img' className="active_img" />
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="language" className='settings_a'>
                                                    <h4><Trans i18nKey="Change Language">Change Language</Trans></h4>
                                                    <img src={rightarrow} alt='img' className="nrml_img" />
                                                    <img src={activearrow} alt='img' className="active_img" />
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="password" className='settings_a'>
                                                    <h4><Trans i18nKey="Change password">Change password</Trans></h4>
                                                    <img src={rightarrow} alt='img' className="nrml_img" />
                                                    <img src={activearrow} alt='img' className="active_img" />
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="deactivate" className='settings_a'>
                                                    <h4><Trans i18nKey="Deactivate account">Deactivate account</Trans></h4>
                                                    <img src={rightarrow} alt='img' className="nrml_img" />
                                                    <img src={activearrow} alt='img' className="active_img" />
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="delete" className='settings_a delete_setting'>
                                                    <h4><Trans i18nKey="Delete account">Delete account</Trans></h4>
                                                    <img src={rightarrow} alt='img' className="nrml_img" />
                                                    <img src={activearrow} alt='img' className="active_img" />
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                </Col>
                                <Col md={7} className=''>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="information" className='settingtab_bg'>
                                            <Information />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="language" className='settingtab_bg'>
                                            <ChangeLanguage />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="password" className='settingtab_bg'>
                                            <ChangeePassword />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="deactivate" className='settingtab_bg'>
                                            <Deactivate />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="delete" className='settingtab_bg'>
                                            <Delete />
                                        </Tab.Pane>
                                    </Tab.Content>

                                </Col>
                            </Row>
                        </Tab.Container>
                    </Container>
                </div>
            </div >
        );
    }
}

export default withTranslation("translations")(Settings);
